import React from 'react'
import { baseUrl } from 'utils/parseDomain'
import 'styles/footerLinks.scss'

function FooterLinks(props) {
  return (
    <div className="container text-center footerNavWrap">
      <div className="row">
        <div className="col-sm-3 navBlock">
          <div className="navHead">Need Help?</div>
          <ul className="nav">
            <li>
              <a href={`${baseUrl}/registration/user/login`}>Member Login</a>
            </li>
            <li>
              <a href={`${baseUrl}/registration/user`}>Sign Up</a>
            </li>
            <li>
              <a href={`${baseUrl}/search`}>Partner Search</a>
            </li>
            <li>
              <a
                href={`${baseUrl}/introduction/index/how-to-use`}
                target="_blank"
                rel="noopener noreferrer"
              >
                How to Use Shaadi.com
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/introduction/index/membership-plans`}>
                Premium Memberships
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/customer-relations/faq/registration`}>
                Customer Support
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/sitemap`}>Site Map</a>
            </li>
          </ul>
        </div>
        <div className="col-sm-3 navBlock">
          <div className="navHead">Company</div>
          <ul className="nav">
            <li>
              <a href={`${baseUrl}/introduction/index/letter-from-cmd`}>
                About Us
              </a>
            </li>
            <li>
              <a
                href="http://blog.shaadi.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Shaadi Blog
              </a>
            </li>
            <li>
              <a
                href="http://affiliate.shaadi.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Affiliate Program
              </a>
            </li>
            <li>
              <a
                href="https://careers.shaadi.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Careers
              </a>
            </li>
            <li>
              <a
                href={`${baseUrl}/introduction/index/why-we-are-no1`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Awards &amp; Recognition
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/contact-us`}>Contact Us</a>
            </li>
          </ul>
        </div>
        <div className="col-sm-3 navBlock">
          <div className="navHead">Privacy &amp; You</div>
          <ul className="nav">
            <li>
              <a href={`${baseUrl}/shaadi-info/index/terms`}>Terms of Use</a>
            </li>
            <li>
              <a href={`${baseUrl}/shaadi-info/index/privacy`}>
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://help.shaadi.com/hc/en-us/articles/203572542-Be-Safe-Online">
                Be Safe Online
              </a>
            </li>
            <li>
              <a
                href="http://help.shaadi.com/hc/en-us/requests/new"
                target="_blank"
                rel="noopener noreferrer"
              >
                Report Misuse
              </a>
            </li>
          </ul>
        </div>
        <div className="col-sm-3 navBlock">
          <div className="navHead">More</div>
          <ul className="nav">
            <li>
              <a
                href="https://www.vipshaadi.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                VIP Shaadi
              </a>
            </li>
            <li>
              <a
                href="https://www.selectshaadi.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Select Shaadi
              </a>
            </li>
            <li>
              <a
                href="https://www.sangam.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sangam
              </a>
            </li>
            <li>
              <a
                href="http://www.shaadicentre.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                Shaadi Centres
              </a>
            </li>
            <li>
              <a
                href={`${baseUrl}/shaadi_info/matrimonial_success_stories/index.php`}
              >
                Success Stories
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default FooterLinks
